function findTimeOffset() {
    let d = new Date();
    let offset = Math.floor(-d.getTimezoneOffset()/60);
    if (offset == 0)
        return 0;
    let isNeg = offset < 0;
    offset = Math.abs(offset);
    offset = offset < 10 ? "0" + offset : offset;

    offset = isNeg ? '-' + offset : '+' + offset;
    offset += ":00";

    return offset;
}

function formatDateUTC(epoch) {
    let d = new Date(epoch);
    let minutes = d.getUTCMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let hours = d.getUTCHours();
    hours = hours < 10 ? "0" + hours : hours;
    let date = d.getUTCDate();
    date = date < 10 ? "0" + date : date;
    let month = d.getUTCMonth() + 1;
    month = month < 10 ? "0" + month : month;

    return d.getUTCFullYear() + '-' + month + '-' + date + ' ' + hours + ':' + minutes + " UTC";
}

function formatDateLT(epoch) {
    let d = new Date(epoch);
    let minutes = d.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let hours = d.getHours();
    hours = hours < 10 ? "0" + hours : hours;
    let date = d.getDate();
    date = date < 10 ? "0" + date : date;
    let month = d.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let offset = Math.floor(-d.getTimezoneOffset()/60);
    if (offset > 0)
        offset = '+' + offset;
    if (offset == 0)
        offset = '';
    else
        offset = "(UTC" + offset + ")";

    return d.getFullYear() + '-' + month + '-' + date + ' ' + hours + ':' + minutes + " " + offset;
}

function formatShortDate(epoch) {
    let d = new Date(epoch);
    let monArr=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let date = d.getDate();
    date = date < 10 ? '0' + date : date;
    return monArr[d.getMonth()] + " " + date;
}

function formatMinutes(minutes) {
    let days = Math.floor(minutes / (24 * 60));
    minutes = minutes % (24 * 60);
    let hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    if (days) {
        return days + " d " + hours + " h " + minutes + " min";
    }
    else if (hours) {
        hours = hours < 10 ? "0" + hours : hours;
        return hours + " h " + minutes + " min";
    }
    else {
        return minutes + " min";
    }
}

function formatPhoneNum(phoneNum) {
    phoneNum = phoneNum.toString();
    let pattern = /(\d{3})(\d{3})(\d{4})/;
    let matched = phoneNum.match(pattern);
    return matched[1] + '-' + matched[2] + '-' + matched[3];
}

function readFromObj(obj, objFormat) {
    // takes an array of objects (formatted as  such: {varName: "name", fieldName: "Name", unit?: "", capitalize?: true, format?: func(val), link?: true) and extracts data from the obj
    // multi level retrieval should be denoted like varName: "vesselType.generic" <- under the assumption that the lower level is also an obj
    
    // make sure the obj passed in isn't undefined, not an object, or an empty object
    if (!(obj && obj instanceof Object && Object.keys(obj).length > 0)) {
        return [];
    }
    
    let formattedArr = [];
    for (let i in objFormat) {
        try { // try catch in order to prevent errors upon nonexistent/unexpected values 
            let listOfVar = objFormat[i]['varName'].split('.');
            let formattedObj = null;
            if (listOfVar.length == 1 && obj[objFormat[i]['varName']] != null) {
                formattedObj = {
                    field: objFormat[i]['fieldName'],
                };

                if (objFormat[i]['link']) {
                    formattedObj['link'] = obj[objFormat[i]['varName']];
                }
                else {
                    formattedObj['val'] = obj[objFormat[i]['varName']];
                }
            }
            else {
                let finalVal = obj;
                for (let v in listOfVar) {
                    finalVal = finalVal[listOfVar[v]]
                }
                if (finalVal != null) {
                    formattedObj = {
                        field: objFormat[i]['fieldName'],
                    };

                    if (objFormat[i]['link']) {
                        formattedObj['link'] = finalVal;
                    }
                    else {
                        formattedObj['val'] = finalVal;
                    }
                }
            }

            if (formattedObj) {
                let valOrLink = objFormat[i]['link'] ? 'link' : 'val';

                if (objFormat[i]['format']) {
                    formattedObj[valOrLink] = objFormat[i]['format'](formattedObj['val']);
                }

                if (formattedObj[valOrLink] === null) {
                    continue;
                }

                if (objFormat[i]['unit'] && !objFormat[i]['link']) {
                    formattedObj['val'] += objFormat[i]['unit']
                }
    
                if (objFormat[i]['capitalize'] && (typeof formattedObj['val'] === 'string' || formattedObj['val'] instanceof String) && !objFormat[i]['link']) {
                    formattedObj['val'] = formattedObj['val'].charAt(0).toUpperCase() + formattedObj['val'].slice(1);
                }
                
                formattedArr.push(formattedObj);
            }
        }
        catch (error) {
            console.log("read from obj:");
            if (error.stack) {
                console.log(error.stack);
            }
            else {
                console.log(error);
            }
        }
       
    }

    return formattedArr;
}

function readFromObjBool(obj, objFormat) {
    // takes an array of objects (formatted as  such: {varName: "name", fieldName: "field name if true"}) and extracts data from the obj
    // will return an array of objects with only field values derived from the given object boolean value
    // multi level retrieval should be denoted like varName: "vesselType.generic" <- under the assumption that the lower level is also an obj
    
    // make sure the obj passed in isn't undefined, not an object, or an empty object
    if (!(obj && obj instanceof Object && Object.keys(obj).length > 0)) {
        return [];
    }
    
    let formattedArr = [];
    for (let i in objFormat) {
        try { // try catch in order to prevent errors upon nonexistent/unexpected values 
            let listOfVar = objFormat[i]['varName'].split('.');
            let formattedObj = null;
            if (listOfVar.length == 1 && obj[objFormat[i]['varName']]) {
                formattedObj = {
                    field: objFormat[i]['fieldName']
                };
            }
            else {
                let finalVal = obj;
                for (let v in listOfVar) {
                    finalVal = finalVal[listOfVar[v]]
                }
                if (finalVal) {
                    formattedObj = {
                        field: objFormat[i]['fieldName']
                    };
                }
            }

            if (formattedObj) {
                formattedArr.push(formattedObj);
            }
        }
        catch (error) {
            console.log("read from obj with bool:");
            if (error.stack) {
                console.log(error.stack);
            }
            else {
                console.log(error);
            }
        }
       
    }

    return formattedArr;
}

module.exports = {
    findTimeOffset,
    formatDateUTC,
    formatDateLT,
    formatShortDate,
    formatMinutes,
    formatPhoneNum,
    readFromObj,
    readFromObjBool
};